import { ISerialisedDocumentReference } from '@principle-theorem/shared';
import { IAppointmentDimension } from '../dimensions/appointment';
import { IBigQueryReferrer, IPatientDimension } from '../dimensions/patient';
import { ITreatmentPlanDimension } from '../dimensions/treatment-plan';
import {
  IBigQueryChartedTreatment,
  IGapScopedFact,
  ITimestampedFact,
} from './common';

export interface IGapFilledFact extends IGapScopedFact, ITimestampedFact {
  patientRef: ISerialisedDocumentReference;
  appointmentRef: ISerialisedDocumentReference;
  treatmentPlanRef: ISerialisedDocumentReference;
  patient: IPatientDimension;
  appointment: IAppointmentDimension;
  treatmentPlan: ITreatmentPlanDimension;
  treatments: IBigQueryChartedTreatment[];
  referrer?: IBigQueryReferrer;
  duration: number;
}
